import { IGallery, IReoEncryptKey } from '@reolink-cloud/interface';
import { createStore, get, set } from 'idb-keyval';

export interface IAccessKeyInfo {
    id: string;
    ck: string;
}

export interface IEventExtraInfo {
    ck: string;
    requestArgs: Record<string, unknown>;
}

export interface IStores {
    encryptKey: {
        get: ( key: string ) => Promise<IGallery['encrypt'] | undefined>;
        set: ( key: string, value: IGallery['encrypt'] ) => Promise<void>;
    };
    encryptDetail: {
        get: ( key: string ) => Promise<IReoEncryptKey | undefined>;
        set: ( key: string, value: IReoEncryptKey ) => Promise<void>;
    };
    accessKey: {
        get: ( key: string ) => Promise<IAccessKeyInfo | undefined>;
        set: ( key: string, value: IAccessKeyInfo ) => Promise<void>;
    };
    eventExtraInfo: {
        get: () => Promise<IEventExtraInfo | undefined>;
        set: ( value: IEventExtraInfo ) => Promise<void>;
    };
}

const encryptKeyStore = createStore( 'sw-encrypt-key-db', 'encrypt-key-store' );
const encryptDetailStore = createStore( 'sw-encrypt-detail-db', 'encrypt-detail-store' );
const accessKeyStore = createStore( 'sw-access-key-db', 'access-key-store' );
const eventExtraInfoStore = createStore( 'sw-event-extra-info-db', 'event-extra-info-store' );

/**
 * 加密媒体相关的 IDB 存储句柄。
 *
 * Service Worker 与主线程通过 import 同一文件，会基于相同的 db/store 名称
 * 拿到同一份 IndexedDB 数据，从而保证降级路径下主线程也能读到 SW 写入的元信息。
 */
export const stores: IStores = {
    encryptKey: {
        get: ( key: string ) => get<IGallery['encrypt']>( key, encryptKeyStore ),
        set: ( key: string, value: IGallery['encrypt'] ) => set( key, value, encryptKeyStore )
    },
    encryptDetail: {
        get: ( key: string ) => get<IReoEncryptKey>( key, encryptDetailStore ),
        set: ( key: string, value: IReoEncryptKey ) => set( key, value, encryptDetailStore )
    },
    accessKey: {
        get: ( key: string ) => get<IAccessKeyInfo>( key, accessKeyStore ),
        set: ( key: string, value: IAccessKeyInfo ) => set( key, value, accessKeyStore )
    },
    eventExtraInfo: {
        get: () => get<IEventExtraInfo>( 'eventExtraInfo', eventExtraInfoStore ),
        set: ( value: IEventExtraInfo ) => set( 'eventExtraInfo', value, eventExtraInfoStore )
    }
};
